// extracted by mini-css-extract-plugin
export default {"step-item":"StepMenus_step-item__XaDVz","step-icon":"StepMenus_step-icon__dh2Z7","step-description":"StepMenus_step-description__BEHYi"};